import { Link, useHistory } from 'react-router-dom';
import { Tab, Tabs } from '@material-ui/core';

// local imports
import { Breadcrumb } from 'app/components/atoms';
import FusePageCarded from '@fuse/core/FusePageCarded';
import CampaignPharmacy from './campaign-pharmacy/campaign-pharmacy';
import CampaignAdd from './campaign-add-edit/campaign-add';
import CampaignEdit from './campaign-add-edit/campaign-edit';
import { useState } from 'react';

const ROUTES = ['add-campaign', 'edit-campaign', 'campaign-pharmacies'];

const ContentToolbar = ({ tabsVal, isEdit, isSubmitted }) => {
  const campaignText = isEdit ? 'Kampanya Güncelle' : 'Kampanya Oluştur';
  const pharmacyTabText = isEdit ? 'Seçilen Eczaneler' : 'Eczane Ekle';
  const firstTabVal = isEdit ? ROUTES[1] : ROUTES[0];
  const disablePharmacySection = !isEdit;
  const disableCampaignSection = !isEdit && isSubmitted;

  return (
    <Tabs
      selectionFollowsFocus
      value={tabsVal}
      indicatorColor="primary"
      textColor="primary"
      variant="scrollable"
      scrollButtons="off"
      className="w-full h-64">
      <Tab
        disabled={disableCampaignSection}
        disableFocusRipple
        disableRipple
        value={firstTabVal}
        className="h-64 text-15 font-semibold tracking-wide"
        label={campaignText}
        role="button"
        component={Link}
        to={firstTabVal}
      />
      <Tab
        disabled={disablePharmacySection}
        disableFocusRipple
        disableRipple
        value={ROUTES[2]}
        className="h-64 text-15 font-semibold tracking-wide"
        label={pharmacyTabText}
        component={Link}
        role="button"
        to={ROUTES[2]}
      />
    </Tabs>
  );
};

const Content = ({ selectedTab, campaignId, setIsSubmitted }) => (
  <div className="p-24">
    {selectedTab === ROUTES[0] && <CampaignAdd />}
    {selectedTab === ROUTES[1] && <CampaignEdit campaignId={campaignId} />}
    {selectedTab === ROUTES[2] && <CampaignPharmacy setIsSubmitted={setIsSubmitted} />}
  </div>
);

const CampaignPageWrapper = ({ match }) => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const history = useHistory();
  const campaignId = match.params.id;
  const isEdit = !!campaignId;
  const selectedTab = history?.location?.pathname.split('/').pop();
  const tabsVal = selectedTab ? selectedTab : false;

  return (
    <>
      <FusePageCarded
        header={<Breadcrumb title="Kampanya Yönetimi" />}
        contentToolbar={
          <ContentToolbar tabsVal={tabsVal} isEdit={isEdit} isSubmitted={isSubmitted} />
        }
        content={
          <Content
            selectedTab={selectedTab}
            isEdit={isEdit}
            campaignId={campaignId}
            setIsSubmitted={setIsSubmitted}
          />
        }
      />
    </>
  );
};

export default CampaignPageWrapper;
